import * as helpers from 'src/api/helpers'
import * as shipments from 'src/api/shipments'
import router from 'src/router'
import {
  GET_SHIPMENT_HELPERS,
  GET_SHIPMENT_STATUS_FILTERS,
  SET_SHIPMENT,
  NEW_SHIPMENT
} from 'src/store/mutation-types'

const getShipmentHelpers = ({commit, dispatch}, params) => {
  dispatch('toggleLoadding', true, {root: true})
  helpers.getShipmentHeppers(params).then(response => {
    dispatch('toggleLoadding', false, {root: true})
    response.statuses.push({status: -1, status_txt: 'Tất cả'})
    commit(GET_SHIPMENT_HELPERS, response)
  })
}
const getFilter = ({commit}, params) => {
  params = typeof params === 'undefined' ? {} : params
  shipments.getFilter(params).then(response => {
    commit(GET_SHIPMENT_STATUS_FILTERS, response.data)
  }).catch(errors => {
    return errors
  })
}
const setShipment = ({commit}, shipment) => {
  commit(SET_SHIPMENT, shipment)
}
const getShipmentDetail = ({commit, dispatch}, configs) => {
  dispatch('toggleLoadding', true, {root: true})
  shipments.getShipment(configs.id, configs.params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(SET_SHIPMENT, response.data)
    } else if (response.code === 404) {
      dispatch('toggleLoadding', false, {root: true})
      dispatch('showNotify', {
        title: 'Không tìm thấy tài nguyên',
        body: 'Vận đơn không tồn tại trên hệ thống',
        type: 'warning'
      }, {root: true})
      router.push({name: 'shipment'})
    } else {

    }
  })
}

const getShipmentDetailComplaint = ({commit, dispatch}, configs) => {
  dispatch('toggleLoadding', true, {root: true})
  shipments.getShipment(configs.id, configs.params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(SET_SHIPMENT, response.data)
    } else if (response.code === 404) {
      dispatch('toggleLoadding', false, {root: true})
      commit(SET_SHIPMENT, {status: 1000, status_txt: 'Đơn đã hủy'})
    } else {

    }
  })
}

const exportExcel = ({commit, dispatch}, params) => {
  dispatch('toggleLoadding', true, {root: true})
  shipments.exportExcel(params).then(response => {
    if (response.code === 200) {
      dispatch('showNotify', {
        title: 'Thành công',
        body: 'Xuất excel thành công'
      }, {root: true})
      window.location.href = response.full
      dispatch('toggleLoadding', false, {root: true})
    } else if (response.code === 404) {
      dispatch('showNotify', {
        title: 'Không tìm thấy tài nguyên',
        type: 'warning'
      }, {root: true})
      dispatch('toggleLoadding', false, {root: true})
      router.push({name: 'client'})
    } else {
      dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const setNewShipment = ({commit}) => {
  commit(NEW_SHIPMENT)
}

export default {
  getShipmentHelpers,
  getFilter,
  setShipment,
  getShipmentDetail,
  setNewShipment,
  exportExcel,
  getShipmentDetailComplaint
}



// WEBPACK FOOTER //
// ./src/components/shipment/store/actions.js